export enum PromotionType {
  QOW = 'Question of the week',
  BECOME_EXPERT = 'BecomeExpert',
  QUIZ = 'Quiz',
  POW = 'Puzzle of the week',
  SPIN_TO_WIN = 'Spin To Win',
  REFER_FRIEND = 'Event Referral',
  LEAP_EXPERT = 'Leap Expert',
  SMART_SELLER = 'Smarter Seller',
  LEARN_COURSES = 'Learn Courses',
}
